import React from 'react';
type LogoProps = {
  size?: 'sm' | 'lg';
  showTagline?: boolean;
  className?: string;
};
function PawHeartMark({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Pawsy Companion paw print logo" data-id="element-82" data-mp="8uwb6ywk60xs">
      <circle cx="16" cy="20" r="7.5" fill="currentColor" data-id="element-83" data-mp="3v8nxhur5a0iq" />
      <circle cx="30" cy="13.5" r="7.5" fill="currentColor" data-id="element-84" data-mp="3v97hri49p0zx" />
      <circle cx="45" cy="17" r="7.5" fill="currentColor" data-id="element-85" data-mp="mskz6flx9o72" />
      <circle cx="55" cy="30" r="6.5" fill="currentColor" data-id="element-86" data-mp="mr1jaq46hf5t" />
      <path d="M32 58c-8-5.4-15-11-15-18.6C17 33 21.6 29 27 29c2.9 0 5.3 1.4 7 3.6 1.7-2.2 4.1-3.6 7-3.6 5.4 0 10 4 10 10.4C51 47 44 52.6 36 58l-2 1.3z" fill="currentColor" data-id="element-87" data-mp="rqmj12r69rjl" />
      <path d="M34 50.5l-1.2-1.1c-3.3-3-5.5-5-5.5-7.5 0-2 1.5-3.5 3.5-3.5 1.1 0 2.2.5 2.9 1.4a3.7 3.7 0 0 1 2.9-1.4c2 0 3.5 1.5 3.5 3.5 0 2.5-2.2 4.5-5.5 7.5l-.6.6z" fill="#FF6F61" data-id="element-88" data-mp="hsghim9a2nf9" />
    </svg>;
}
export function Logo({
  size = 'sm',
  showTagline = false,
  className = ''
}: LogoProps) {
  const isLarge = size === 'lg';
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-89" data-mp="19vwv858czimk">
      <PawHeartMark className={`${isLarge ? 'h-14 w-14' : 'h-9 w-9'} shrink-0 text-paw`} data-id="element-90" data-mp="19xhpruuob1kf" />
      <div data-id="element-91" data-mp="1nwhgr95nrsjr">
        <p className={`font-display font-extrabold leading-none tracking-[-0.02em] text-paw ${isLarge ? 'text-3xl sm:text-4xl' : 'text-xl'}`} data-id="element-92" data-mp="1nx0vyi3xc2u3">
          Pawsy <span className="text-ink-700" data-id="element-93" data-mp="1xsaz59626g9g">Companion</span>
        </p>
        {showTagline && <p className="mt-1.5 font-mono text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-ink-500" data-id="element-94" data-mp="1su9ewkwwcawe">
            Care Smarter. <span className="text-orangey-500" data-id="element-95" data-mp="27li1sm9ezi5u">Love More.</span>
          </p>}
      </div>
    </div>;
}